import PropTypes from 'prop-types';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import ProjectService from '../../services/ProjectService';
import {t} from 'i18next';
import CriteriaCalendarRangeComponent from '../../components/criteria/CriteriaCalendarRangeComponent';
import ClientService from '../../services/ClientService';
import NumberUtils from '../../utils/NumberUtils';
import { Chip } from 'primereact/chip';
import ProjectCategoryService from '../../services/ProjectCategoryService';
import CriteriaMultiSelectComponent from '../../components/criteria/CriteriaMultiSelectComponent';
import InternalUserService from '../../services/InternalUserService';
import ExternalSupervisorService from '../../services/ExternalSupervisorService';
import { PrintButtonComponent } from '../../report/ReportUtils';
import AccommodationService from '../../services/AccommodationService'
import YesNoDialog from '../../components/YesNoDialog';

import ColorUtils from '../../components/utils/ColorUtils';
import ActionButtonBuilder from '../../utils/ActionButtonBuilder';
import { withRouter } from "react-router-dom";
import { Button } from 'primereact/button';

class ProjectListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new ProjectService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [],
            categories: [],
            clients: [],
            element: {                
                name: '',                
                status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            },
            showConfirmCloseProject: false,
            projectToClose: undefined
        };
        this.clientService = new ClientService();
        this.projectCategoryService = new ProjectCategoryService();
        this.internalUserService = new InternalUserService();
        this.externalSupervisorService = new ExternalSupervisorService();
        this.accommodationService = new AccommodationService();

        this.handleProjectClone = this.handleProjectClone.bind(this);
        this.renderClosePojectComponent = this.renderClosePojectComponent.bind(this);
        this.onRowDoubleClick = this.onRowDoubleClick.bind(this);

        const profile = this.authService.getProfile();
        this.panelRatioEnabled = profile.panelRatioEnabled;
        this.projectSupervisorEnabled = profile.projectSupervisorEnabled;
        this.accommodationEnabled = profile.accommodationEnabled;
        this.projectExternalSupervisorEnabled = profile.projectExternalSupervisorEnabled;
    }

    updateSearchCriteria(criteria) {
        return {
            name: criteria.name,
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            categories: criteria.categories,
            client: criteria.client,
            status: criteria.status,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
            externalSupervisor: criteria.externalSupervisor,
            projectManager: criteria.projectManager,
            supervisor: criteria.supervisor,
            accommodation: criteria.accommodation,
            basicFilter: criteria.basicFilter
        };
    }

    getCleanSearchCriteria() {        
        return {
            name: '',
            status:  {enumValue: 'ACTIVE', label: 'Aktywny'},
            id: null,
            dateFrom: null,
            dateTo: null,
            categories: [],
            client: null,
            firstResult: 0,
            maxResults: 10,
            sortField: 'name',
            sortAsc: true,
            projectManagerId: null,
            accommodation: undefined,
            basicFilter: null
        };
    }

    initializeFromBackend() {
        this.enumService
            .getEnumList('ProjectStatus')
            .then((statusOptions) =>
                this.setState({
                    statusOptions,
                })
            )
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });
        this.projectCategoryService.getList({ firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true })
            .then(categories => this.setState({ categories: categories.content }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy kategorii');
            });

            //projectManagerOptions
        this.internalUserService.getSimpleList('ROLE_TIMESHEET_APPROVE')
            .then(users => this.setState({ projectManagerOptions: users}))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy menedżerów');
            });
        if (this.projectExternalSupervisorEnabled) {
            this.externalSupervisorService
                .getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'id', sortAsc: true })
                .then(data => this.setState({ externalSupervisorOptions: data.content }))
                .catch(() => {
                    this.showErrorMessage('Nie udało się pobrać listy opiekunów');
                });
        }

        if (this.projectSupervisorEnabled) {
            this.internalUserService.getSimpleList(['ROLE_TIMESHEET_APPROVE','ROLE_USER_TYPE_SUPERVISOR'])
                .then(users => this.setState({ supervisorOptions: users }))
                .catch(() => {
                    this.showErrorMessage('Nie udało się pobrać listy menedżerów');
                });
        }

        if (this.accommodationEnabled) {
            this.accommodationService
                .getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'id', sortAsc: true })
                .then((data) => {
                    this.setState({ accommodationOptions: data.content });
                }).catch((err) => {
                    this.showErrorMessage('Nie udało się pobrać listy noclegów');
                });
        }
        this.clientService.getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true })
            .then(clients => {
                clients.content.forEach(client => {
                    this.clientService.keepOnly(client, 'id', 'name');
                })
                this.setState({ clients: clients.content });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy klientów');
            });
    }

    renderPrintButton() {
        return (
            <PrintButtonComponent
                key={`print-button-pay-report`}
                reportFileNameBase={t('project.listName')}
                xml={false}
                pdf={false}
                csv={false}
                ods={false}
                xlsx={false}
                globalFormat='xlsx'
                noMenuFlag={true}
                generateReport={this.generateReport.bind(this)}
                disabled={!this.state.list.length > 0}
            />
        );
    }
    generateReport(format) {
        const criteria = this.state.criteria;
        switch (format) {
            case 'xlsx':
                return this.service.exportList(criteria, 'xlsx');
            default:
                return Promise.reject('Nieznany format');
        }
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.name}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('project.name')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                  <CriteriaCalendarRangeComponent
                    id='date-sc'
                    idFrom='dateFrom-sc'
                    idTo='dateTo-sc'
                    label={t('project.date')}
                    labelFrom={'od'}
                    labelTo={'do'}
                    name='date'
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    colClass='col-xl-8 col-lg-8 col-sm-12'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    sharedLabel
                    maxDateInfinite
                    placeholderFrom={''}
                    placeholderTo={''}
                    inputsClassName='col-6'
                />                
                <CriteriaDropdownComponent
                    id='client-sc'
                    name='client'
                    showClear
                    label={t('project.clientName')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.client}
                    options={this.state.clients}
                    placeholder='Wybierz'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='name'
                    filterOptionValue='name'
                    dataKey='id'
                    refreshFromBackend
                />
                <CriteriaMultiSelectComponent
                    id='categories'
                    name='categories'
                    label={t('project.categories')}
                    colClass='col-md-4'
                    onChange={this.handleChangeSc}
                    options={this.state.categories}
                    optionLabel='name'
                    value={this.state.criteria.categories}                                            
                    dataKey='id'
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                    display='chip-colored'
                    chipColor='color.value'
                    filter
                    filterBy='name'
                />
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={t('project.status')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.statusOptions}
                    placeholder='Wybierz'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    filterOptionValue='label'
                    refreshFromBackend
                />

                <CriteriaDropdownComponent
                    id='pm-sc'
                    name='projectManager'
                    showClear
                    label={t('project.details.projectManager')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.projectManager}
                    options={this.state.projectManagerOptions}
                    placeholder='Wybierz'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='fullName'
                    filterOptionValue='fullName'
                    refreshFromBackend
                    filter={true}
                    filterBy='fullName'
               />
               {this.projectSupervisorEnabled ? (
                <CriteriaDropdownComponent
                        id='supervisor-sc'
                        name='supervisor'
                        showClear
                        label={t('project.details.supervisor')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.supervisor}
                        options={this.state.supervisorOptions}
                        placeholder='Wybierz'
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        optionLabel='fullName'
                        filterOptionValue='fullName'
                        refreshFromBackend
                        filter={true}
                        filterBy='fullName'
                />
                ) : null}
                {this.projectExternalSupervisorEnabled ? (
                    <CriteriaDropdownComponent
                        id='externalSupervisor-sc'
                        name='externalSupervisor'
                        showClear
                        label={t('project.details.externalSupervisor')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.externalSupervisor}
                        options={this.state.externalSupervisorOptions}
                        placeholder='Wybierz'
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        optionLabel='fullName'
                        filterOptionValue='fullName'
                        refreshFromBackend
                        filter={true}
                        filterBy='fullName'
                    />
                ) : null}
                {this.accommodationEnabled ? (
                    <CriteriaDropdownComponent
                        id='accommodation-sc'
                        name='accommodation'
                        showClear
                        label={t('project.details.accommodation')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.accommodation}
                        options={this.state.accommodationOptions}
                        placeholder='Wybierz'
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        optionLabel='name'
                        filterOptionValue='name'
                        refreshFromBackend
                        filter={true}
                        filterBy='name'
                    />
                ) : null}
            </div>
        );
    }
    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }

    handleProjectClone(rowData) {
        const { newUrl } = this.props;
        window.location.href = this.navigationContext.addNavigationContextToUrl(`${newUrl}/${rowData.id}`);
    }

    handleProjectClose(rowData) {
        this.setState({
            showConfirmCloseProject: true,
            projectToClose: {
                id: rowData.id,
                name: rowData.name
            }
        });
    }

    getActionTemplateOptions(rowData) {        
        const items = [];
        if (this.authService.isUserInAnyRole('ROLE_PROJECT_VIEW')) {
            items.push({isDetailOption: true});
        }
        if (this.authService.isUserInAnyRole('ROLE_PROJECT_EDIT', 'ROLE_TIMESHEET_APPROVE', 'ROLE_USER_TYPE_ADMIN')) {
            const status = rowData?.status?.enumValue;
            if (status === 'ACTIVE'){
                items.push({isEditOption: true});
            }
            items.push({label: t('project-list.cloneProjectButton'), iconClassName: 'pi pi-clone', command: () => this.handleProjectClone(rowData)})
            if (status === 'ACTIVE') {
                items.push({label: t('project-list.closeProjectButton'), iconClassName: 'pi pi-times-circle', command: () => this.handleProjectClose(rowData)});
            }
        }
                
        return items;
    }


    projectStatusTempleta(item) {
        return (
            <Chip
                label={item?.status?.label}
                className={item?.status?.enumValue === 'ACTIVE' ? 'project-status-active' : 'project-status-closed'}
            />
        )
    }

    prepareColumns() {
        const result = [
            {field: 'name', header: t('project.name'), sortable: true},
            {field: 'client.name', header: t('project.clientName'), sortable: true},
            {field: 'categories', header: t('project.categories'), sortable: false, body: this.categoriesTemplate.bind(this)},
            {field: 'dateStart', header: t('project.dateStart'), sortable: true},
            {field: 'dateEnd', header: t('project.dateEnd'), sortable: true}
        ];
        if (this.panelRatioEnabled) {
            result.push({field: 'panelRatio', header: t('project.panelRatio'), sortable: true, sortField: 'summary.panelRatio', body: this.panelRationTemplate.bind(this)});
        }
        result.push({field: 'status', header: t('project.status'), sortable: true, body: this.projectStatusTempleta.bind(this)});
        result.push({
            key: 'actions',
            header: t('list.actions'),
            body: this.actionTemplate,
            className: 'table-column-action',
        });
        return result;
    }

    categoriesTemplate(rowData) {
        if (rowData?.categories) {
            return (
                rowData.categories.map(c => {
                    return (
                        <Chip style={{
                            backgroundColor:c?.color?.value,
                            color: ColorUtils.getContrastingColor(c?.color?.value)}} label={c.name} />
                    )
                })
            )
        } else {
            return '';
        }
    }

    panelRationTemplate(rowData) {
        const panelRatio = rowData['panelRatio'];
        if (panelRatio) {
            return (
                <span>{NumberUtils.formatNumber(panelRatio, 6, 6)}</span>
            )
        } else {
            return '';
        }

    }

    prepareHeaderItems() {
        return this.authService.isUserInAnyRole('ROLE_PROJECT_EDIT')
            ? [
                  {
                      label: t('project.newProject'),
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'blue',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                      iconColor: 'white',
                      onClick: this.handleGoToNew,
                  },
                  {
                    type: 'BUTTON',
                    className: 'right-side',
                    variant: 'white',
                    disabled: !this.state.list || this.state.list.length < 1,
                    customRenderFunction: this.renderPrintButton,
                },
              ]
            : [];
    }

    onRowDoubleClick(event) {
        this.handleGoToDetail(this.generateGoToDetailUrl(event.data), event.originalEvent)
    }


    renderClosePojectComponent() {
        return (
            <YesNoDialog
                visible={this.state.showConfirmCloseProject}
                header={t('project-list.closeHeader')}
                name='visible'
                onChange={(a, b, target) => {
                    if (target.value) {
                        this.blockUi();
                        this.service
                            .closeProject(this.state.projectToClose?.id)
                            .then(() => {
                                this.refreshTable()
                            })
                            .catch((error) => {
                                this.showErrorMessage(error.message);
                            })
                            .finally(() => {
                                this.unblockUi();
                                this.setState({
                                    showConfirmCloseProject: false,
                                    projectToClose: {}
                                });
                            });
                    } else {
                        this.setState({ showConfirmCloseProject: false, projectToClose: {} });
                    }
                }}
                onHide={() => {
                    this.setState({ showConfirmCloseProject: false, projectToClose: {} });
                }}
            >
                {`${t('project-list.closeMessage')} ${this.state.projectToClose.name} ?`}
            </YesNoDialog>
        );
    }

    render() {
        return (
            <div className='container-fluid'>
                {this.renderView()}                
                { this.state.showConfirmCloseProject && this.renderClosePojectComponent() }
            </div>
        );
    }
}

ProjectListContainer.defaultProps = {
    detailUrl: '/#/project/details',
    newUrl: '/#/project/create',
    editUrl: '/#/project/edit',
    //disableSelection: true,
    lazy: true,
};

ProjectListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(ProjectListContainer);
